<div class="container">
  <div class="page-container">
    <div class="page-title">User Management</div>
    <mat-divider class="divider-top"></mat-divider>
    <div class="subtitle-row">
      <div class="left-section">
        <div class="total-users">{{ startIndex }} - {{ endIndex }} of {{ totalItems }} Total Users</div>
        <div class="pagination-select table-container">
          <mat-form-field>
            <mat-select (selectionChange)="goToPage(1)" [(value)]="paginationTotal" class="select-filter">
              <mat-option [value]="20">20 Per page</mat-option>
              <mat-option [value]="40">40 Per page</mat-option>
              <mat-option [value]="100">100 Per page</mat-option>
              <mat-option [value]="99999">Show All</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div
          (click)="clearFilters()"
          [className]="
            this.getBaseQueryString() === this.getFullQueryString() ? 'clear-filter disabled-filter' : 'clear-filter'
          "
          color="primary"
          mat-stroked-button>
          Clear All Filters
        </div>
      </div>
      <div class="right-section">
        <div *ngIf="!enableBulkButtons" class="select-instruction">Select at least one row to enable bulk controls</div>
        <button (click)="onCSVExport()" [disabled]="!enableBulkButtons" class="bulk-action-button" id="csv-export">
          Export CSV
        </button>
        <div class="invite" *ngIf="!this.currentUser.isLimitedAdmin">
          <button data-cy="invite-user-button" (click)="openUserDialog()" color="primary" mat-raised-button>
            INVITE USER
          </button>
        </div>
      </div>
    </div>

    <mat-divider class="divider-bottom"></mat-divider>
    <div class="table-container">
      <table [dataSource]="dataSource" mat-table aria-describedby="User Permission Table">
        <!-- Checkbox Column -->
        <ng-container matColumnDef="select">
          <th scope="col" *matHeaderCellDef mat-header-cell class="checkbox-cell">
            <mat-checkbox
              (change)="$event ? masterToggle() : null"
              [aria-label]="checkboxLabel()"
              [checked]="selection.hasValue() && isAllSelected()"
              [indeterminate]="selection.hasValue() && !isAllSelected()"></mat-checkbox>
          </th>
          <td (click)="$event.stopPropagation()" *matCellDef="let row" class="checkbox-cell" mat-cell>
            <mat-checkbox
              (change)="$event ? selection.toggle(row) : null"
              (click)="$event.stopPropagation()"
              [aria-label]="checkboxLabel(row)"
              [checked]="selection.isSelected(row)"></mat-checkbox>
          </td>
        </ng-container>
        <ng-container matColumnDef="email">
          <th scope="col" *matHeaderCellDef mat-header-cell>
            <div (click)="toggleSingleSort('email')" class="header-with-sort">
              <span>Email</span>
              <span [class]="sortBy['email']" id="sort-icon-container">
                <fc-sort-icon [column]="'email'" [sortBy]="sortBy" [sortStates]="sortStates"></fc-sort-icon>
              </span>
            </div>
            <mat-form-field>
              <input
                #filterEmail
                (keyup)="applyFilter($event, 'email')"
                [(value)]="filterValues.email"
                matInput
                placeholder="Filter" />
            </mat-form-field>
          </th>
          <td *matCellDef="let row" mat-cell>
            <div>
              <a [routerLink]="['/admin/profile', row.id]">
                {{ row.email }}
                {{ row.id === currentUser.id ? '(You)' : null }}
              </a>
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="user_fullname">
          <th scope="col" *matHeaderCellDef mat-header-cell>
            <div (click)="toggleSingleSort('first_name')" class="header-with-sort">
              <span>Name</span>
              <span [class]="sortBy['first_name']" id="name-sort-icon-container">
                <fc-sort-icon [column]="'first_name'" [sortBy]="sortBy" [sortStates]="sortStates"></fc-sort-icon>
              </span>
            </div>
            <mat-form-field>
              <input
                #filterFullName
                (keyup)="applyFullNameFilter($event, 'user_fullname')"
                [(value)]="filterValues.user_fullname"
                matInput
                placeholder="Filter" />
            </mat-form-field>
          </th>
          <td *matCellDef="let row" mat-cell>
            {{ row.getDisplayName({ includeEmail: false }) }}
          </td>
        </ng-container>
        <ng-container matColumnDef="isActive">
          <th scope="col" *matHeaderCellDef mat-header-cell>
            <div>Active</div>
          </th>
          <td *matCellDef="let row" mat-cell>
            <div *ngIf="row.isActive; else showInactive">
              <fa-icon [icon]="['fas', 'check']" class="green size-20" title="Is Active"></fa-icon>
            </div>
            <ng-template #showInactive>
              <fa-icon [icon]="['far', 'triangle-exclamation']" class="orange size-20"></fa-icon>
            </ng-template>
          </td>
        </ng-container>

        <ng-container matColumnDef="validated">
          <th scope="col" *matHeaderCellDef mat-header-cell>
            <div>Email Validated</div>
          </th>
          <td *matCellDef="let row" mat-cell>
            <div *ngIf="!row.lastLogin; else isValidated">
              <button
                *ngIf="!this.currentUser.isLimitedAdmin; else xmark"
                (click)="resendInvite($event, row)"
                color="primary"
                mat-stroked-button>
                Resend Invite
              </button>
              <ng-template #xmark>
                <fa-icon [icon]="['far', 'xmark']" class="red size-20" title="Not Validated"></fa-icon>
              </ng-template>
            </div>
            <ng-template #isValidated>
              <fa-icon [icon]="['fas', 'check']" class="green size-20" title="Is Validated"></fa-icon>
            </ng-template>
          </td>
        </ng-container>

        <ng-container matColumnDef="verified">
          <th scope="col" *matHeaderCellDef mat-header-cell>
            <div>Identity Verified</div>
            <mat-form-field>
              <mat-select
                (selectionChange)="applyVerifiedFilter($event, 'verified')"
                [(value)]="filterValues.verified"
                class="select-filter"
                panelClass="verified-panel"
                placeholder="Filter">
                <mat-option [value]="">None</mat-option>
                <mat-option *ngFor="let verificationStatus of verificationStatuses" [value]="verificationStatus">
                  {{ verificationStatus }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </th>
          <td *matCellDef="let row" mat-cell>
            <span *ngIf="row.isAdmin; else notAnAdmin">--</span>
            <ng-template #notAnAdmin>
              <fa-icon
                *ngIf="getVerificationStatus(row) === 'Rejected'"
                [icon]="['far', 'xmark']"
                class="red size-20"
                title="Rejected"></fa-icon>
              <fa-icon
                *ngIf="getVerificationStatus(row) === 'Failed'"
                [icon]="['far', 'triangle-exclamation']"
                class="orange size-20"
                title="Failed"></fa-icon>
              <fa-icon
                *ngIf="getVerificationStatus(row) === 'Pending'"
                [icon]="['far', 'circle-question']"
                class="orange size-20"
                title="Pending"></fa-icon>
              <fa-icon
                *ngIf="getVerificationStatus(row) === 'Verified'"
                [icon]="['fas', 'check']"
                class="green size-20"
                title="Is Verified"></fa-icon>
            </ng-template>
          </td>
        </ng-container>

        <ng-container matColumnDef="numSites">
          <th scope="col" *matHeaderCellDef mat-header-cell>
            <span>Submitted Sites</span>
          </th>
          <td *matCellDef="let row" mat-cell>
            {{ row.isLandowner ? row.numSubmittedSites : '' }}
          </td>
        </ng-container>
        <ng-container matColumnDef="role">
          <th scope="col" *matHeaderCellDef mat-header-cell>
            <div>Role</div>
            <mat-form-field *ngIf="!this.currentUser.isLimitedAdmin">
              <mat-select
                (selectionChange)="applyRoleFilter($event, 'role')"
                [(value)]="filterValues.role"
                class="select-filter"
                panelClass="role-panel"
                placeholder="Filter">
                <mat-option [value]="">None</mat-option>
                <mat-option *ngFor="let role of roles" [value]="role">
                  {{ role }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </th>
          <td *matCellDef="let row" mat-cell>
            <ng-container *ngIf="userIsSuperAdmin; else isOnlyAdmin">
              <a
                mat-button
                color="primary"
                [class.disabled]="row.id === currentUser.id"
                class="fc-green-link"
                data-cy="edit-permissions-button"
                (click)="openUserDialog(row)">
                <fa-icon [icon]="['fas', 'edit']"></fa-icon>
                {{ row.roles.length > 0 ? row.roles[0].getName() : 'No Role' }}
              </a>
            </ng-container>
            <ng-template #isOnlyAdmin>
              <div *ngIf="row.roles.length > 0">
                {{ row.roles[0].getName() }}
              </div>
              <div *ngIf="row.roles.length === 0">No Role</div>
            </ng-template>
          </td>
        </ng-container>

        <tr *matHeaderRowDef="displayedColumns" mat-header-row></tr>
        <tr *matRowDef="let row; columns: displayedColumns" mat-row></tr>
        <div *ngIf="dataSource && dataSource.data.length === 0" class="empty-results">No users found...</div>
      </table>
      <fc-spinner [overlay]="true" name="user-spinner" text="Loading Users"></fc-spinner>
    </div>

    <mat-divider class="divider-top"></mat-divider>

    <fc-table-pagination
      [totalPages]="totalPages"
      (goToPage)="goToPage($event)"
      [currentPage]="currentPage"
      [showPages]="showPages"></fc-table-pagination>
  </div>
</div>
